import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 6,
    backgroundColor: theme.palette.grey[100],
    marginTop: 8,
    marginBottom: 8
  },
  header: { padding: theme.spacing(2) },
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2)
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  roomBlock: {
    marginBottom: theme.spacing(2)
  },
  roomHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 500
  },
  icon: { fontSize: 20, color: theme.palette.text.primary },
  verticalAlign: {
    fontWeight: 500,
    fontSize: '1rem',
    display: 'flex',
    verticalAlign: 'middle',
    lineHeight: '22px'
  },
  profileIcon: {
    fontSize: 20,
    color: theme.palette.grey[700],
    marginRight: 4
  },
  greyText: { fontWeight: 600, color: theme.palette.grey[600] },
  blackText: { fontWeight: 500, color: theme.palette.text.primary },
  personCard: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 8,
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default
  },
  iconBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingRight: theme.spacing(2),
    minWidth: 80
  },
  iconText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginBottom: 6
  },
  personLabel: {
    fontSize: 14,
    fontWeight: 500
  },
  personRole: {
    fontSize: 12,
    color: '#888'
  },
  detailsBox: {
    flexGrow: 1,
    paddingLeft: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    borderLeft: `1px solid ${theme.palette.grey[400]}`,
    gap: theme.spacing(1)
  },
  fullName: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 4,
    color: '#222'
  },
  email: {
    fontSize: 12,
    color: '#666'
  },
  phone: {
    fontSize: 12,
    color: '#666',
    marginLeft: 'auto'
  },
  row: { display: 'flex', alignItems: 'center', marginRight: 16 },
  formIcon: {
    color: theme.palette.grey[500],
    fontSize: 18,
    marginRight: 8,
    alignSelf: 'center'
  }
}))
